export const useConvertQuillDeltaToSpans = (
  ops: any,
  fontSize: number,
  color: string = "#000000",
  includeLineBreaks: boolean = true
) => {
  if (ops == null || ops == undefined) return [];

  const textRunsArray = [];

  let currentTextRuns = [] as any[];
  ops.forEach((op: any) => {
    if (typeof op.insert === "string") {
      // Determine formatting from attributes

      const lines = (op.insert as string).split("\n");

      let index = 0;
      for (const line of lines) {
        const lineDiv = document.createElement('div');


        const formatting = op.attributes || {};


        const textSpan = document.createElement('span');
        textSpan.innerText = useRemoveEmojis(line.replace(/[\u200B-\u200D\uFEFF]/g, "")) + " ";
        textSpan.style.fontSize = `${fontSize}pt`;
        textSpan.style.color = color;
        textSpan.style.fontWeight = formatting.bold ? "bold" : "normal";
        textSpan.style.fontStyle = formatting.italic ? "italic" : "normal";
        textSpan.style.textAlign = "left";

        // Handle underlines and strikethroughs
        if (formatting.underline) {
          textSpan.style.textDecoration = "underline";
        }

        if (formatting.strike) {
          textSpan.style.textDecoration = "line-through";
        }

        // Add both underline and strikethrough to the span
        if (formatting.underline && formatting.strike) {
          textSpan.style.textDecoration = "underline line-through";
        }



        lineDiv.appendChild(textSpan);


        currentTextRuns.push(textSpan);

        if (lines.length > 1 && index < lines.length - 1 && includeLineBreaks) {
          const lineBreakSpan = document.createElement('span');
          lineBreakSpan.innerText = "\n";
          currentTextRuns.push(lineBreakSpan);
          // currentTextRuns.push(lineBreakSpan);
          textRunsArray.push(currentTextRuns);
          currentTextRuns = [];
        }

        index++;
      }
    }

    // if ((op.insert as string).includes("\n") && includeLineBreaks) {
    //   textRunsArray.push(currentTextRuns);
    //   currentTextRuns = [];
    // }
  });

  // Handle any remaining TextRuns
  if (currentTextRuns.length > 0) {
    textRunsArray.push(currentTextRuns);
  }



  return textRunsArray;
}
